/**
 * @generated SignedSource<<f312b9e3dba3addabceafa54aabc41a4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "version"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "version",
        "variableName": "version"
      }
    ],
    "concreteType": "Impulse",
    "kind": "LinkedField",
    "name": "sendImpulse",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ImpulseImplSendMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ImpulseImplSendMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cc2913974d1dbbd2b69333d9426a45fe",
    "id": null,
    "metadata": {},
    "name": "ImpulseImplSendMutation",
    "operationKind": "mutation",
    "text": "mutation ImpulseImplSendMutation(\n  $id: String\n  $version: Int\n) {\n  sendImpulse(id: $id, version: $version) {\n    id\n  }\n}\n"
  }
};
})();

node.hash = "48cb0ced6a01798769117f2a502c6fdb";

module.exports = node;
